import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          <div className="flex items-center">
            <button
              onClick={() => scrollToSection('hero')}
              className="flex items-center space-x-2 cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/f384832b5a766ad07a1721f0b33de73e/6ee0193abd8804ba3f9736fe623d9173.png" 
                alt="URI Logo" 
                className="h-12 sm:h-16 md:h-20 w-auto"
              />
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.home')}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.testimonials')}
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.faq')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-uri-teal whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {t('nav.contact')}
            </button>
            <button
              onClick={() => scrollToSection('booking')}
              className="bg-uri-teal text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-uri-teal-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('nav.bookNow')}
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.home')}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.testimonials')}
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.faq')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-uri-teal py-2 cursor-pointer"
            >
              {t('nav.contact')}
            </button>
            <button
              onClick={() => scrollToSection('booking')}
              className="block w-full bg-uri-teal text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-uri-teal-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('nav.bookNow')}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
